<template>
  <div ref="container">
    <div class="sign-record">
      <div class="list">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="data">{{ item.time }}</div>
          <div class="collectionGoods">
            <router-link
              :to="{ path: '/detail/' + item.pid }"
              class="item acea-row row-between-wrapper"
              v-for="(val, key) in item.list"
              :key="key"
            >
              <div class="pictrue"><img :src="val.image" /></div>
              <div class="text acea-row row-column-between">
                <div class="infor line1">{{ val.storeName }}</div>
                <div class="acea-row row-between-wrapper">
                  <div class="money font-color-red">
                    {{ val.price }}<span class="co-integral">积分</span>
                  </div>
                  <div
                    class="delete"
                    @click.prevent="delCollection(index, key)"
                  >
                    删除
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
    <div
      class="noCommodity"
      style="background-color:#fff;"
      v-if="list.length < 1 && page > 1"
    >
      <div class="noPictrue">
        <img src="@images/noCollection.png" class="image" />
      </div>
      <Recommend></Recommend>
    </div>
  </div>
</template>
<script>
import Recommend from "@components/Recommend";
import { getFootUser, getCollectDel } from "@api/user";
import Loading from "@components/Loading";
export default {
  name: "GoodsCollection",
  components: {
    Recommend,
    Loading
  },
  props: {},
  data: function() {
    return {
      page: 1,
      limit: 5,
      list: [],
      loadTitle: "",
      loading: false,
      loadend: false
    };
  },
  mounted: function() {
    this.get_user_collect_product();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.get_user_collect_product();
    });
  },
  methods: {
    get_user_collect_product: function() {
      let that = this;
      if (that.loading) return;
      if (that.loadend) return;
      that.loading = true;
      getFootUser(that.page, that.limit).then(res => {
        that.loading = false;
        that.list.push.apply(that.list, res.data);
        that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
        that.page = that.page + 1;
      });
    },
    //删除收藏；
    delCollection: function(index, key) {
      let that = this;
      let footList = that.list[index].list;
      let id = footList[key].pid,
        category = footList[key].category;
      getCollectDel(id, category).then(function() {
        that.$dialog.toast({
          mes: "删除足迹成功!"
        });
        footList.splice(key, 1);
        that.list[index].list = footList;
        that.$set(that, "list", that.list);
      });
    }
  }
};
</script>
